import { Component, Input } from '@angular/core';
import { AccessibilityService } from '@core-mkt/services/accessibility/accessibility.service';
import { FaIconComponent, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import type { IconPrefix } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebookSquare,
  faInstagram,
  faLinkedin,
  faTiktok,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import type { FooterLinkGroup } from '../footer/footer';
import { QueryParamDirective } from '@core-mkt/services/query-param/query-param.directive';

@Component({
  selector: 'footer-link',
  templateUrl: './footer-link.component.html',
  styleUrls: ['./footer-link.component.scss'],
  standalone: true,
  imports: [FaIconComponent, QueryParamDirective],
})
export class FooterLinkComponent {
  @Input() links: FooterLinkGroup[];
  @Input() footerLocation: string;
  @Input() alignClass = '';
  @Input() linkClass = '';
  iconPrefix: IconPrefix = 'fab';

  constructor(library: FaIconLibrary, private accessibilityService: AccessibilityService) {
    library.addIcons(faXTwitter, faTiktok, faYoutube, faFacebookSquare, faLinkedin, faInstagram);
  }

  get flexDirection(): string {
    if (this.footerLocation !== 'bottom' && this.footerLocation !== 'social') {
      return 'flex-wrap flex-col';
    }
    if (this.footerLocation === 'bottom') {
      return 'md:flex-row';
    }
    return 'md:flex-wrap md:flex-col';
  }

  get layout(): string {
    if (this.footerLocation === 'bottom') {
      return 'lg:justify-end';
    }
    return 'tablet-halved';
  }
}
